import React, { useCallback, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { fetchTourVirtualStatus, markTourVirtualComplete } from './tourVirtualApi';
import { getOryaTourSettings } from './oryaTourConstants';
import './OryaVirtualTour.css';

const TOUR_HTML_SRC = `${process.env.PUBLIC_URL || ''}/tours/orya-tour-v2.html?embed=1`;

export function OryaVirtualTour({ enabled = false, onOpenDocumentation }) {
  const [open, setOpen] = useState(false);
  const completingRef = useRef(false);

  useEffect(() => {
    if (!enabled) {
      setOpen(false);
      return undefined;
    }

    let cancelled = false;
    (async () => {
      const { active, tourKey, tourVersion } = getOryaTourSettings();
      if (!active || !tourVersion) return;

      try {
        const completed = await fetchTourVirtualStatus(tourKey, tourVersion);
        if (!cancelled && !completed) setOpen(true);
      } catch {
        /* MySQL indisponível — não exibe tour */
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  const finish = useCallback(
    async (mode) => {
      if (completingRef.current) return;
      completingRef.current = true;
      try {
        const { tourKey, tourVersion } = getOryaTourSettings();
        if (tourKey && tourVersion) {
          await markTourVirtualComplete(tourKey, tourVersion);
        }
      } catch {
        /* persistência opcional */
      }
      setOpen(false);
      if (mode === 'docs') onOpenDocumentation?.();
    },
    [onOpenDocumentation],
  );

  useEffect(() => {
    if (!open) return undefined;

    const onMessage = (event) => {
      if (event?.data?.source !== 'painelos-orya-tour') return;
      finish(event.data.action === 'docs' ? 'docs' : 'later');
    };

    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [open, finish]);

  if (!open) return null;

  return createPortal(
    <div className="orya-tour-overlay" role="dialog" aria-modal="true" aria-label="Tour Orya">
      <iframe className="orya-tour-frame" src={TOUR_HTML_SRC} title="Tour Orya" loading="eager" />
    </div>,
    document.body,
  );
}
